import api from "../api/api";
import { appState } from "../redux/redux-config";

const payment = {
  getPaymentMethods: async function () {
    let token = appState().user.token;
    let result = await api.payment.getPaymentMethods(token);
    if (result.success) {
      return result;
    }
  },
  addPaymentMethod: async function (data) {
    let token = appState().user.token;
    return await api.payment.addPaymentMethod(token, data);
  },
  updatePaymentMethod: async function (data) {
    let token = appState().user.token;
    return await api.payment.updatePaymentMethod(token, data);
  },
};

export default payment;
